import { render, staticRenderFns } from "./play-pause-layer.vue?vue&type=template&id=533551b6&"
import script from "./play-pause-layer.vue?vue&type=script&lang=js&"
export * from "./play-pause-layer.vue?vue&type=script&lang=js&"
import style0 from "./play-pause-layer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports